package ir.site.zero1plus.theme

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.components.navigation.LinkStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.link
import com.varabyte.kobweb.silk.style.selectors.visited
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.input
import com.varabyte.kobweb.silk.theme.colors.palette.link
import com.varabyte.kobweb.silk.theme.modifyStyle

//dark
val PrimaryDark = Color.rgb(0x00FFFF)

val BackgroundDark = Color.rgb(0x0D1117)

val LinkDark = Color.rgb(0x00CCCC)

val HoverColor = Color.rgb(0x00E0E0)

val LinkHoverColorDark = Color.rgb(0x33FFFF)
val LinkVisitedDark = Color.rgb(0x009999)

val SurfaceDark = Color.rgb(0x161B22)

val TextPrimaryDark = Color.rgb(0xE6EDF3)

val TextSecondaryDark = Color.rgb(0x8B949E)

val ErrorDark = Color.rgb(0xFF4D4D)

// light
val PrimaryLight = Color.rgb(0x00BFBF)

val HoverLight = Color.rgb(0x00D9D9)

val BackgroundLight = Color.rgb(0xF9FBFF)

val SurfaceLight = Color.rgb(0x00EDF2F7)

val BorderLight = Color.rgb(0xE2E8F0)
val LinkLight = Color.rgb(0x00A3A3)

val TextPrimaryLight = Color.rgb(0x0A0A0A)

val TextSecondaryLight = Color.rgb(0x4A5568)

val ErrorLight = Color.rgb(0xE63946)

val LinkHoverColorLight = Color.rgb(0x00D9D9)

val LinkVisitedLight = Color.rgb(0x00A3A3)




@InitSilk
fun overrideSilkTheme(ctx: InitSilkContext) {
    /*ctx.stylesheet.registerStyleBase("a"){ // todo this modify all the a tag element
        Modifier.color(Colors.Red)
    }*/
    ctx.theme.modifyStyle(LinkStyle){
        val isDark = colorMode.isDark
        link{
            Modifier.color(if (isDark) LinkDark else LinkLight)
        }
        visited{
            Modifier.color(if (isDark) LinkVisitedDark else LinkVisitedLight)
        }
        hover{
            Modifier.color(if (isDark) LinkHoverColorDark else LinkHoverColorLight)
        }
    }
    ctx.theme.palettes.apply {
        light.apply {
            background = BackgroundLight
            color = TextPrimaryLight
        }
        dark.apply {
            background = BackgroundDark
            color = TextPrimaryDark
            input.filledFocus = Colors.Red
            input.filled = Colors.Red
            input.filledHover = Colors.Red
            input.hoveredBorder = Colors.Red

        }
    }
}
